import React, {ChangeEvent, useState} from "react"; //
import {useTranslation} from "react-i18next"; //
import style from "./Lesson.module.css";

interface LessonPropsDI {lessonText:string}

const Lesson: React.FC<LessonPropsDI> = (props) => {
  const { t } = useTranslation();

  return (
    <div id={t('lesson-lesson-text')} tabIndex={1} className={style.wrapper}>
      <h1 className={style.title}>{t('Lesson-lesson-text')}</h1>
      <div className={style.separator}>
        <span></span>
      </div>
      <p tabIndex={1}  className={style.content} title={props.lessonText}>
        {props.lessonText}
      </p>
    </div>
  );
};

// export default observer(LessonForm);
export default Lesson;
